import { StyledCalendarView } from './CalendarView.style';
import Calendar from './Calendar.js';
import LegendMenu from './LegendMenu/LegendMenu';
import useCalendarView from './useCalendarView';

const CalendarView = ({ forecast }) => {
  const { dateInView, setDateInView, monthsInView, handleMonthChange } =
    useCalendarView();

  return (
    <StyledCalendarView>
      <Calendar
        forecast={forecast}
        dateInView={dateInView}
        handleMonthChange={handleMonthChange}
      />
      <LegendMenu monthsInView={monthsInView} setDateInView={setDateInView} />
    </StyledCalendarView>
  );
};

export default CalendarView;
